var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobility(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "33.63,30.05 40.53,30.05 25.51,13.01 10.5,30.05 17.38,30.05 25.51,20.97  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.29,33.99L25.49,7L1.71,33.99h15.78L8.52,44h8.02l8.96-10.01L34.46,44h8.01l-8.96-10.01H49.29z M5.67,32.2L25.49,9.71 L45.32,32.2H31.91l-6.41-7.16l-6.41,7.16H5.67z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobility);
export default __webpack_public_path__ + "static/media/mobility.6b81f48b1dc190e5a2add0248c0a1ab5.svg";
export { ForwardRef as ReactComponent };